let config = {
    title: 'Jujutsu Kaisen: Arcane Battle',
    email: 'support@jujutsukaisenarcanebattle.com',
    policy: 'https://jujutsukaisenarcanebattle.com/privacy_policy.html',
    term: 'https://jujutsukaisenarcanebattle.com/terms.html', 
    copyright: '© 2024 Hainan Mijia Network Technology Co., Ltd',
    introduceTitle: [
       'In Jujutsu Kaisen: Arcane Battle, you’ll enter a 3D world brimming with jujutsu and mystery. The game features captivating storylines and exquisite effects, with each adventure presenting its own set of unknowns and challenges. Strategically utilize jujutsu skills and tactics to explore this challenging world alongside other players.'
    ],
    introduceText: [
        {
            title: '#Stunning 3D Visuals#',
            text: [
                'Experience intricate 3D graphics with smooth animations and immersive battle scenes.'
            ]
        },
        {
            title: '#Diverse Combat Modes#',
            text: [
                'Engage in various PVP and PVE combat modes to cater to different player preferences.'
            ]
        },
        {
            title: '#Challenging Dungeons#',
            text: [
                'Each dungeon is designed with unique difficulty levels, offering thrilling combat experiences and rich rewards.'
            ]
        },
        {
            title: '#Exquisite Effects and Skills#',
            text: [
                'Show off impressive jujutsu skills and effects that make every battle visually spectacular.'
            ]
        },
        {
            title: '#Rich Reward System#',
            text: [
                'Complete challenges and missions to earn valuable rewards and enhance your character’s abilities.'
            ]
        }
    ]
}
export default config;